import { use_slice_collections, use_slice_ui } from '@/hooks/store/use_slices';
import { FOOTER__master } from '@/pages/_base/layout_footer/FOOTER__master';
import { GRID2D__master } from '../_base/grid2d/views/GRID2D__master';
import { SIDEBAR__image_compare } from '../_base/grid2d_sidebar_image_compare/SIDEBAR__image_compare';
import { LAYOUT_COLUMN__left } from '../_base/layout_base/LAYOUT_COLUMN__left';
import { HEADER__master } from '../_base/layout_header/HEADER__master';
import { C_SIDEBAR__collections } from './_bars/C_SIDEBAR__collections';
import { TopbarInfoCollectionCurrent } from './TopbarInfoCollectionCurrent';

export function C_PAGE_LAYOUT__collections_desktop() {
  const { collection_current } = use_slice_collections(['collection_current']);
  const { global__grid2d_show_as_gallery } = use_slice_ui(['global__grid2d_show_as_gallery']);

  /*
   * RENDERS
   */

  function render_collection_current() {
    if (collection_current.is_stub()) return null;

    return <GRID2D__master entity_id={collection_current._id} entity_type={collection_current.type} />;
  }

  /*
   * HTML
   */

  return (
    <div className="flex flex-col w-full h-screen">
      <HEADER__master column_center={<></>} column_right={<></>} />

      <div className="flex flex-row w-full flex-1 min-h-0">
        <LAYOUT_COLUMN__left could_be_hidden>{global__grid2d_show_as_gallery ? <SIDEBAR__image_compare /> : <C_SIDEBAR__collections />}</LAYOUT_COLUMN__left>

        <div className="flex-1 h-full">{render_collection_current()}</div>
      </div>

      <FOOTER__master />
    </div>
  );

  return (
    <>
      <TopbarInfoCollectionCurrent />
    </>
  );
}
